import { shorthandParser } from './attributes';

interface PaddingOverrideArgs {
  type: string;
  keepContainerPaddingScreenS?: boolean;
  padding?: string;
}

const allEqual = (arr: number[]) => arr.every((v) => v === arr[0]);

export const typeLimits = {
  body: '20px',
  column: '0px',
  section: '24px',
  single: '20px',
};

export const paddingOverride = ({
  keepContainerPaddingScreenS = false,
  padding,
  type,
}: PaddingOverrideArgs): string | null => {
  if (!padding) {
    return null;
  }
  if (padding.includes('%') || keepContainerPaddingScreenS) {
    return padding;
  }

  const componentType = type.toLowerCase();

  const limit = typeLimits[componentType];

  if (!limit) {
    return padding;
  }

  const paddingTop = shorthandParser(padding, 'top');
  const paddingRight = Math.min(
    shorthandParser(padding, 'right'),
    parseInt(limit, 10),
  );
  const paddingBottom = shorthandParser(padding, 'bottom');
  const paddingLeft = Math.min(
    shorthandParser(padding, 'left'),
    parseInt(limit, 10),
  );

  if (allEqual([paddingTop, paddingRight, paddingBottom, paddingLeft])) {
    return `${paddingTop}px`;
  }

  return `${paddingTop}px ${paddingRight}px ${paddingBottom}px ${paddingLeft}px`;
};
